import { Component, computed, inject, input } from "@angular/core";
import { FormBuilder, ReactiveFormsModule, Validators } from "@angular/forms";
import { TranslocoPipe } from "@jsverse/transloco";
import { DirectusTranslationPipe } from "../../../../common/pipes/directus-translation.pipe";
import { FormControlHasErrorPipe } from "../../../../common/pipes/form-control-has-error.pipe";
import { FormGroupGetPipe } from "../../../../common/pipes/form-group-get.pipe";
import { PathFromItemPipe } from "../../../../common/pipes/path-from-item.pipe";
import {
    sanitizeDirectusObject,
    sanitizeDirectusRelationObject
} from "../../../../common/utils/sanitize-directus-object";
import { ItemsContactFormBlock } from "../../../api/packbo/models/items-contact-form-block";
import { ItemsContactFormSubmissions } from "../../../api/packbo/models/items-contact-form-submissions";
import { ContactFormBlockService } from "./store/contact-form-block.service";
import { ContactFormBlockStore } from "./store/contact-form-block.store";

@Component({
    selector: "packbo-contact-form-block",
    templateUrl: "./contact-form-block.template.html",
    providers: [ContactFormBlockService, ContactFormBlockStore],
    imports: [
        TranslocoPipe,
        ReactiveFormsModule,
        PathFromItemPipe,
        DirectusTranslationPipe,
        FormGroupGetPipe,
        FormControlHasErrorPipe
    ]
})
export class ContactFormBlockComponent {
    private readonly contactFormBlockStore = inject(ContactFormBlockStore);
    private readonly contactFormBlockService = inject(ContactFormBlockService);
    private readonly formBuilder = inject(FormBuilder);

    public readonly contactFormBlock = input.required<ItemsContactFormBlock>();

    protected readonly isSubmitting = this.contactFormBlockStore.submitting;

    protected readonly privacyPolicy = computed(() =>
        sanitizeDirectusObject(this.contactFormBlock()?.privacy_policy_navigation_item_ref)
    );
    protected readonly privacyPolicyPageRef = computed(() =>
        sanitizeDirectusRelationObject(this.contactFormBlock()?.privacy_policy_navigation_item_ref, "page_ref")
    );

    protected readonly formGroup = this.formBuilder.group({
        firstname: ["", [Validators.required]],
        lastname: ["", [Validators.required]],
        businessName: ["", [Validators.required]],
        email: ["", [Validators.required, Validators.email]],
        object: ["", [Validators.required]],
        message: ["", [Validators.required]],
        subscribeToNewsletter: [false],
        acceptPrivacyPolicy: [false]
    });

    public onContactFormSubmit(): void {
        if (this.formGroup.invalid || !this.formGroup.controls.acceptPrivacyPolicy.value) {
            this.formGroup.markAllAsTouched();
            return;
        }

        const submissionForm: ItemsContactFormSubmissions = {
            email: this.formGroup.controls.email.value,
            firstname: this.formGroup.controls.firstname.value,
            lastname: this.formGroup.controls.lastname.value,
            business_name: this.formGroup.controls.businessName.value,
            object: this.formGroup.controls.object.value,
            message: this.formGroup.controls.message.value,
            subscribe_to_newsletter: this.formGroup.controls.subscribeToNewsletter.value
        };

        this.contactFormBlockService.createContactFormSubmission(submissionForm).subscribe(() => {
            this.formGroup.reset();
        });
    }
}
